import { useCallback, KeyboardEvent } from 'react';

type AccessibleKeyPress = (event: KeyboardEvent<HTMLDivElement>) => void;

const useAccessibleKeyPress = (onClick: () => void): AccessibleKeyPress => {
  return useCallback((event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault(); // Impede o scroll ao pressionar Space
      onClick();
    }
  }, [onClick]);
};

export default useAccessibleKeyPress;
